import React from "react";
import BaseDialog from "./BaseDialog";

export default function CommonDialog(props) {
  const {
    open,
    title,
    subText,
    subTextColor,
    action = true,
    LeftButtonText = "취소",
    RightButtonText = "확인", 
    childrenBox,
    onClick1,
    onClick2,
    onClose,
    className,
  } = props;

  return (
    <BaseDialog
      open={open}
      title={title}
      content={subText}
      contentColor={subTextColor}
      actionType={action ? "double" : "none"}
      leftButtonText={LeftButtonText}
      rightButtonText={RightButtonText}
      onLeftClick={onClick1}
      onRightClick={onClick2}
      onClose={onClose}
      className={className}
    >
      {childrenBox && <div>{childrenBox}</div>}
    </BaseDialog>
  );
}
